import axios from 'axios'
import { ApiUrl } from '../services/url'
export const AuthApi = {
  register: async (data) => {
    let Query = {
      query: `
      mutation {
        userSignup(signUpInput:{
          fname:${JSON.stringify(data.fname)},
          lname:${JSON.stringify(data.lname)},
          mobile:${JSON.stringify(data.mobile)},
          password:${JSON.stringify(data.password)}
        })
        {
          message
          code
      }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, JSON.stringify(Query), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  sendCode: async (mobile) => {
    let Query = {
      query: `
      mutation {
        userSendOtp(sendOtp:{
          mobile:${JSON.stringify(mobile)}
        })
        {
          message
          code
      }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, JSON.stringify(Query), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },

  codeVerify: async (code, mobile) => {
    let Query = {
      query: `
      mutation {
        userOtpVerify(codeInput:{
          mobile:${JSON.stringify(mobile)}
          code:${code}
        })
        {
          user{
            mobile
          }
          token
      }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, JSON.stringify(Query), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  reset: async (data, mobile, code) => {
    let Query = {
      query: `
      mutation {
        userForgetPassword(input:{
          mobile:${JSON.stringify(mobile)}
          code:${JSON.stringify(code)}
          password:${JSON.stringify(data.password)}
          confirm_password:${JSON.stringify(data.confirm_password)}
        })
        {
          message
      }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, JSON.stringify(Query), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  login: async (data) => {
    let Query = {
      query: `
      mutation {
        userLogin(input:{
          mobile:${JSON.stringify(data.mobile)}
          password:${JSON.stringify(data.password)}
        }){
        user{
          _id
           mobile
        }
        token
      }
    }
      `,
    }
    return await axios.post(`${ApiUrl}`, JSON.stringify(Query), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
}
